import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { catchError, map, of } from 'rxjs';

export class BuildInfo {
  public timestamp: Date | string | undefined;
  public version: string | undefined;
  public commitHash: string | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class BuildInfoService {
  private readonly http = inject(HttpClient);

  public buildInfoResource = rxResource({
    params: () => 'build-info.json',
    stream: ({ params }) =>
      this.http.get<BuildInfo | undefined>(params).pipe(
        catchError(() => of(undefined)),
        map(
          (data) =>
            ({
              timestamp: data?.timestamp ? new Date(data.timestamp) : undefined,
              version: data?.version,
              commitHash: data?.commitHash,
            }) as BuildInfo,
        ),
      ),
  });
}
